import { useContext } from 'react';
import { WizardContext, type WizardContextValue } from './WizardContext';

export const useWizard = (): WizardContextValue => {
  const context = useContext(WizardContext);
  if (context === undefined) {
    throw new Error('useWizard must be used within a WizardProvider');
  }
  return context;
};
